import { render, staticRenderFns } from "./IconTextLink.vue?vue&type=template&id=1555e475&"
import script from "./IconTextLink.vue?vue&type=script&lang=ts&"
export * from "./IconTextLink.vue?vue&type=script&lang=ts&"
import style0 from "./IconTextLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports